import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { lumi } from './lib/lumi'
import Login from './pages/Login'
import Cadastro from './pages/Cadastro'
import Dashboard from './pages/Dashboard'

import CriarProposta from './pages/CriarProposta'
import PropostaPublica from './pages/PropostaPublica'
import Onboarding from './pages/Onboarding'
import Historico from './pages/Historico'
import Configuracoes from './pages/Configuracoes'
import CriarContrato from './pages/CriarContrato'
import NotaFiscal from './pages/NotaFiscal'

import ComprovantePagamento from './pages/ComprovantePagamento'
import AnaliseVendas from './pages/AnaliseVendas'
import FunilVendas from './pages/FunilVendas'
import CalendarioEntregas from './pages/CalendarioEntregas'

function App() {
  const [user, setUser] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [onboardingComplete, setOnboardingComplete] = useState(false)

  useEffect(() => {
    const checkAuth = async () => {
      const currentUser = await lumi.auth.refreshUser()
      setUser(currentUser)
      const completed = localStorage.getItem('onboardingComplete')
      setOnboardingComplete(completed === 'true')
      setLoading(false)
    }
    checkAuth()

    const unsubscribe = lumi.auth.onAuthChange((newUser) => {
      setUser(newUser)
      // Recheck onboarding status when auth changes
      const completed = localStorage.getItem('onboardingComplete')
      setOnboardingComplete(completed === 'true')
    })

    return () => unsubscribe()
  }, [])

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-red-600 text-xl font-semibold">Carregando...</div>
      </div>
    )
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={!user ? <Login /> : <Navigate to={onboardingComplete ? "/dashboard" : "/onboarding"} replace />} />
        <Route path="/cadastro" element={!user ? <Cadastro /> : <Navigate to={onboardingComplete ? "/dashboard" : "/onboarding"} replace />} />
        <Route path="/onboarding" element={user ? <Onboarding /> : <Navigate to="/login" replace />} />
        <Route path="/dashboard" element={user && onboardingComplete ? <Dashboard /> : <Navigate to={user ? "/onboarding" : "/login"} replace />} />

        <Route path="/criar-proposta" element={user && onboardingComplete ? <CriarProposta /> : <Navigate to={user ? "/onboarding" : "/login"} replace />} />
        <Route path="/proposta/:id" element={<PropostaPublica />} />
        <Route path="/configuracoes" element={user && onboardingComplete ? <Configuracoes /> : <Navigate to={user ? "/onboarding" : "/login"} replace />} />
        <Route path="/criar-contrato" element={user && onboardingComplete ? <CriarContrato /> : <Navigate to={user ? "/onboarding" : "/login"} replace />} />
        <Route path="/nota-fiscal" element={user && onboardingComplete ? <NotaFiscal /> : <Navigate to={user ? "/onboarding" : "/login"} replace />} />
        <Route path="/comprovante-pagamento" element={user && onboardingComplete ? <ComprovantePagamento /> : <Navigate to={user ? "/onboarding" : "/login"} replace />} />
        <Route path="/analise-vendas" element={user && onboardingComplete ? <AnaliseVendas /> : <Navigate to={user ? "/onboarding" : "/login"} replace />} />
        <Route path="/funil-vendas" element={user && onboardingComplete ? <FunilVendas /> : <Navigate to={user ? "/onboarding" : "/login"} replace />} />
        <Route path="/calendario-entregas" element={user && onboardingComplete ? <CalendarioEntregas /> : <Navigate to={user ? "/onboarding" : "/login"} replace />} />
        <Route path="/" element={<Navigate to={user ? (onboardingComplete ? "/dashboard" : "/onboarding") : "/login"} replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
